import moment from "moment";
import React, { useState } from "react";
import {
  Apiurl,
  GetLocalStorageParsed,
  stringifyData,
} from "../../Pages/utils/page";
import { BsStar } from "react-icons/bs";
import { BsStarFill } from "react-icons/bs";
import axios from "axios";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

const OrderDetail = ({
  orderData,
  GetOrders,
  handlePrevPage,
  handleNextPage,
  pageNumber,
  setPageNumber,
  totalRecord,
  setNumberofRecordSelected,
  numberOfRecordSelected,
}) => {
 
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [show, setShow] = useState(false);
  const [review, setReview] = useState("");
  const [reviewData, setReviewData] = useState();
  const handleClose = () => {
    setShow(false);
    setReview();
    setReviewData();
  };

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [rating, setRating] = useState(0);

  const handleRating = (e, value, item) => {
    setRating(value);
    // return
    const data = {};
    data.Id = reviewData?.FeedBackId || item?.FeedBackId;
    data.OrderId = reviewData?.OrderId || item?.OrderId;
    data.ProductId = reviewData?.ProductId || item?.ProductId;
    if (e === "rev") {
      data.Review = review ;
      data.Rating = reviewData?.Rating;
    }
    if (e === "star") {
      data.Review = item?.Review;

      data.Rating = value;
    }
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/AddUpdateFeedback`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        GetOrders();
        handleClose();
        setReviewData();

        setReview("");
      })
      .catch((error) => {});
  };

  return (
    <div className="tab-content_data">
      <div>
        {orderData?.length ? (
          orderData?.map((item) => {
            const imagesArray = JSON.parse(item.ProductImageSrc);
            const defaultImage = imagesArray?.find((img) => img.Default);
            const imageUrl = defaultImage
              ? `${Apiurl()}/${defaultImage.Images}`
              : "";

            return (
              <div className="col-lg-12" key={item.id}>
                <div className="invoice-group">
                  <div className="order_summery_products">
                    <div className="order-bg">
                      <div className="row">
                        <div className="col-lg-3">
                          <img
                            src={imageUrl}
                            className="w-100"
                            alt="Product"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/Images/no-product-img-700.jpg";
                            }}
                          />
                        </div>
                        <div className="col-lg-9">
                          <div className="row">
                            <div className="col-lg-6">
                              <div>
                                <h2>{item?.ProductName}</h2>
                                <p>{item?.ProductName}</p>
                                <p>Paid: ₹ {item?.TotalPaidAmount}</p>
                              </div>
                            </div>
                            <div className="col-lg-2">
                              <p>Qty: {item?.ProductUnit}</p>
                            </div>
                            <div className="col-lg-4">
                              <div>
                                <p className="progress_txt">
                                  <strong>{item?.OrderStatus}</strong>
                                </p>
                                <p>
                                  On{" "}
                                  {moment(item?.OrderDate).format(
                                    "MMMM Do YYYY"
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              {/* {item?.OrderStatus == "Delivered" ? ( */}
                              <div className="review_rate_list">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                      key={star}
                                      onClick={() =>
                                        handleRating("star", star, item)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        marginRight: 5,
                                      }}
                                    >
                                      {star <= item?.Rating ? (
                                        <BsStarFill />
                                      ) : (
                                        <BsStar />
                                      )}
                                    </span>
                                  ))}
                                  {item?.Review ? <p></p> : null}
                                </div>
                                {item?.Rating ? (
                                  <p>
                                    {!item?.Rating
                                      ? " Rate &amp; Review"
                                      : item?.Review
                                      ? `Review: ${item.Review}`
                                      : null}
                                    <span
                                      onClick={() => {
                                        setShow(true);
                                        setReviewData(item);
                                      }}
                                    >
                                      {item.Review
                                        ? "Update Review"
                                        : " Write Review"}
                                    </span>
                                  </p>
                                ) : null}
                              </div>
                              {/* ) : null} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="order_summ_footr">
                    <div className="row">
                      <div className="col-lg-6 form_go_btn d-flex w-100 justify-content-between">
                        <p>Invoice Number: {item?.InvoiceNumber}</p>
                        <p>Order Id: {item?.OrderId}</p>
                      </div>
                      {/* <div className="col-lg-6">
                        <button type="button" className="common_btn btn-primary get_order_invoice">
                          Get Invoice
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>No Order Summary Yet!</p>
        )}
      </div>
      {orderData?.length > 0 ? (
        <div className="row">
          <div className="col-lg-4">
            <div className="pagination-summary">
              <span>
                Displaying{" "}
                {Math.min(
                  pageNumber * (numberOfRecordSelected || 10) + 1,
                  totalRecord
                )}
                -
                {Math.min(
                  (pageNumber + 1) * (numberOfRecordSelected || 10),
                  totalRecord
                )}
                of {totalRecord} records
              </span>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="pagination-controls">
              <button
                className="btn btn-secondary"
                onClick={() => handlePrevPage()}
                disabled={pageNumber == 0}
              >
                Previous
              </button>

              {Array.from(
                {
                  length: Math.ceil(
                    totalRecord / (numberOfRecordSelected || 10)
                  ),
                },
                (_, i) => {
                  return (
                    <>
                      <button
                        className={
                          pageNumber === i
                            ? "btn btn-primary active_page_number"
                            : "btn btn-light"
                        }
                        onClick={() => GetOrders(i, "pag")}
                      >
                        <span key={i}>{i + 1}</span>
                      </button>
                    </>
                  );
                }
              )}

              <button
                className="btn btn-secondary"
                onClick={() => handleNextPage()}
                disabled={
                  pageNumber ===
                  Math.ceil(totalRecord / (numberOfRecordSelected || 10)) - 1
                }
              >
                Next
              </button>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="records-per-page pull-right">
              <label for="recordsPerPage">Records per page:</label>
              <select
                id="recordsPerPage"
                className="form-select"
                onChange={(e) => {
                  setPageNumber(0);
                  setNumberofRecordSelected(e?.target?.value);
                  GetOrders("", "i", e?.target?.value);
                }}
              >
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      ) : null}

      <Modal
        backdrop="static"
        className="review_write_modal"
        show={show}
        onHide={handleClose}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="common_heading mb-0" b-ilpho4ovw6="">
              Add Review
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <textarea
            rows="5"
            placeholder="Write Something About the Item..."
            className="w-100 review_bordr"
            b-ilpho4ovw6=""
            onChange={(e) => setReview(e?.target?.value)}
            value={review || reviewData?.Review}
          ></textarea>
        </Modal.Body>
        <Modal.Footer className="Login-modal-footer">
          <button
            type="button"
            className="common_btn btn-secondary"
            data-bs-dismiss="modal"
            b-ilpho4ovw6=""
            onClick={handleClose}
          >
            Close
          </button>
          <input
            type="button"
            className="common_btn view-data-btn"
            value="Submit Review"
            b-ilpho4ovw6=""
            onClick={() => handleRating("rev")}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OrderDetail;
